import { EMPTY_STRING } from '../../../../../constants/common'

export function getNextValue(event) {
  const nextEvent = { ...event }

  nextEvent.target.value = event.target.value.replace(/\D+/g, EMPTY_STRING)

  return nextEvent
}
